// import Tooltip from "@ui/external/components/tooltip";
import { ColumnType } from "@utils/interface/index.interface";
import { MatchesType } from "../../column/index.column";
import CricketPopOver from "@pages/dashboard/marketingEvents/_components/CricketPopOver";
import CricketDialog from "@pages/dashboard/marketingEvents/_components/CricketDialog";
import { PencilIcon } from "lucide-react";
import { UpdateWinnersForm } from "../form/index.form";
import CricketFlag from "../../../_components/CricketFlag";

const ColumnList = () => {
  const column: ColumnType<MatchesType>[] = [
    {
      name: "ID",
      cell: (row) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Team 1",
      cell: (row) => (
        <p className="flex gap-2 items-center">
          <CricketFlag
            isoCode={row.cricket_team1.iso_code}
            className="text-2xl w-8 h-8"
            title={row.cricket_team1.name}
          />
          {row?.cricket_team1.name}
        </p>
      ),
    },
    {
      name: "Team 2",
      cell: (row) => (
        <p className="flex gap-2 items-center">
          <CricketFlag
            isoCode={row.cricket_team2.iso_code}
            className="text-2xl w-8 h-8"
            title={row.cricket_team2.name}
          />
          {row?.cricket_team2.name}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Toass Winner",
      cell: (row) => {
        return <p className="text-[#00A650]">{row?.toss_winner?.name}</p>;
      },
    },
    {
      name: "Match Winner",
      cell: (row) => {
        return <p className="text-[#00A650]">{row?.match_winner?.name}</p>;
      },
    },
    {
      name: "Player of Match",
      cell: (row) => {
        return (
          <p className="text-[#00A650]">{row?.player_of_the_match?.name}</p>
        );
      },
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className=" cursor-pointer">
          {/* <CricketPopOver> */}
          <CricketDialog
            title="Update Winners"
            trigger={
              <div className="flex gap-2 items-center">
                <p className="text-[#00A650]">Edit</p>
              </div>
            }
          >
            <UpdateWinnersForm formdata={row} />
          </CricketDialog>
          {/* </CricketPopOver> */}
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
